/**
 * @generated SignedSource<<95bf1423c09754bc43d045ed5d4691ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditContentButton_content$data = {
  readonly id: string | null;
  readonly metadata: {
    readonly frontend: {
      readonly collabService: string | null;
      readonly embedded: boolean;
      readonly fabricEditorSupported: boolean | null;
    } | null;
  };
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly space: {
    readonly id: string | null;
    readonly key: string | null;
  } | null;
  readonly subType: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "EditContentButton_content";
};
export type EditContentButton_content$key = {
  readonly " $data"?: EditContentButton_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditContentButton_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EditContentButton_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
          "kind": "LinkedField",
          "name": "frontend",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fabricEditorSupported"
            },
            {
              "kind": "ScalarField",
              "name": "embedded"
            },
            {
              "kind": "ScalarField",
              "name": "collabService"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "944dc7aa5d92850342f0cc75e8d65010";

export default node;
